const HowTo = () => {
  const steps = [
    {
      title: "Shop for Your Quill",
      description: "Shop our collection to find the perfect Quill for your space—ideal for your car, your coffee table, or as a thoughtful gift for someone special.",
      buttonText: "Shop Now!",  // Adding button for Shop
      buttonLink: "/store",  // Your store link
    },
    {
      title: "Scan to Setup",
      description: "Once you receive your Quill, simply scan the QR code to get started and set up your message.",
    },
    {
      title: "Update Anytime",
      description: "Keep your message fresh and up-to-date! Easily update it anytime from your dashboard—no hassle involved.",
    },
  ];

  return (
    <>
      {/* Blank White Section Above */}
      <section className="bg-white mt-5" style={{ minHeight: '80px' }}></section>

      {/* Main How-To Section */}
      <section className="my-5 text-center px-3 mb-9 mt-6">
        <h1 className="mb-4">Get started today!</h1>
        <p className="lead mb-5">
          It’s fast, simple, and you can update your message at any time.
        </p>
        <div className="row justify-content-center">
          {steps.map((step, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="p-4 rounded shadow-sm h-100 bg-white">
                <h2 className="mb-3 text-black">{step.title}</h2>
                <p className="mb-3 text-black">{step.description}</p>
                {step.buttonText && (
                  <a href={step.buttonLink} className="btn btn-primary">
                    {step.buttonText}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default HowTo;
